var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col" },
    [
      _c("p", { staticClass: "step-caption ft-bld" }, [
        _vm._v("Configure your manual row"),
      ]),
      _vm._v(" "),
      _c("InputWrapper", {
        attrs: { placeholder: "Row name", "max-chars": 18 },
        model: {
          value: _vm.Global.newRowOverlay.name,
          callback: function ($$v) {
            _vm.$set(_vm.Global.newRowOverlay, "name", $$v)
          },
          expression: "Global.newRowOverlay.name",
        },
      }),
      _vm._v(" "),
      _c("SelectOptsWrapper", {
        attrs: { caption: "Place this row", opts: _vm.displayAfterList },
        model: {
          value: _vm.Global.newRowOverlayDisplayAfter,
          callback: function ($$v) {
            _vm.$set(_vm.Global, "newRowOverlayDisplayAfter", $$v)
          },
          expression: "Global.newRowOverlayDisplayAfter",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nxt-out" }, [
        _c(
          "div",
          {
            staticClass: "btn bck",
            style: _vm.Global.rowIdToEdit
              ? { opacity: 0, pointerEvents: "none" }
              : null,
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("prv")
              },
            },
          },
          [_c("span", { staticClass: "txt" }, [_vm._v("Back")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.switchStep("nxt")
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("Continue")]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }